module.exports = __webpack_public_path__ + "img/SplashBox.c773ae3d.png";